import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { BPartner } from 'src/app/model/other-catalogs-models';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';

@Component({
  selector: 'app-release-new-partner',
  templateUrl: './release-new-partner.component.html',
  styleUrls: ['./release-new-partner.component.css']
})
export class ReleaseNewPartnerComponent implements OnInit {

  IdAsesor:string = '';
  NombreAsesor:string = null; 
  nota:string= '' ;
  ajusteComision:number;
  BPartner : BPartner; 


  constructor(private commissionSalePromotionsService:CommissionSalePromotionsService,
    private toastr:ToastrService,
    private modalService: NgbModal) { }
    public comentarioAjuste: string='';
    public ajuste : boolean =false;
    public userId =Number(localStorage.getItem('com_token')) 

  ngOnInit() {
  }

  close=()=> {

    this.modalService.dismissAll();
  }

  GetBPartner=(idempleado: string)=> {
   
    this.commissionSalePromotionsService.GetBPartner(idempleado)
    
      .pipe(
        tap((resp:any)=> {

        this.BPartner = resp.data; 
        
        this.NombreAsesor = this.BPartner[0].nombreasesor; 
        console.log (this.NombreAsesor)
        //this.modalService.dismissAll();
        //this.toastr.success("Las comisiones se han guardado con éxito.")
        
        }),
        catchError(error=> {
          console.log(error)
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo asesores.'));
        })
      )
      .subscribe();
  }

  SetCommissionDispositionDetail=(action: number)=> {
   
 
    
    this.commissionSalePromotionsService.SetCommissionDispositionDetail(this.IdAsesor, this.ajusteComision, (this.ajusteComision *-1), 0 , this.userId, action ,  this.nota )
    
      .pipe(
        tap((resp:any)=> {

          console.error(resp.data)
        this.modalService.dismissAll();
        this.toastr.success("La retención se agregó con éxito. Consulte de nuevo para validar")
        
        }),
        catchError(error=> {
          console.log(error)
          
          return of(this.toastr.error('Ocurrió un error al leer el catálogo asesores.'));
        })
      )
      .subscribe();
  }


}
